module.exports = __webpack_public_path__ + "media/images/lb/827-b3182ab9a174b527d4f061e1ae32ff09.svg";